import { Box, SegmentedControl, SegmentedControlItem, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';

interface SegmentedInputProps {
  label: string;
  withAsterik?: boolean;
  disabled?: boolean;
  options: (string | SegmentedControlItem)[];
  error?: React.ReactNode;
  defaultValue?: string;
  value?: string;
  onChange: (_value: string) => void;
}

const SegmentedInput: React.FC<SegmentedInputProps> = ({
  label,
  options,
  defaultValue,
  disabled,
  error,
  withAsterik,
  onChange,
  value
}) => {
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (defaultValue) {
      setTextValue(defaultValue);
    }

    return () => {
      setTextValue('');
    };
  }, []);

  useEffect(() => {
    setTextValue(value || '');
  }, [value]);

  const handleChange = (value: string) => {
    onChange(value);
    setTextValue(value);
  };

  return (
    <Box>
      {label && (
        <Text c={'dark'} size='sm' fw={500} mb={3}>
          {label}{' '}
          {withAsterik && (
            <Text component='span' c={'red'}>
              *
            </Text>
          )}
        </Text>
      )}
      <SegmentedControl
        color='primary.7'
        value={textValue}
        onChange={handleChange}
        data={options}
        disabled={disabled}
      />
      {error && (
        <Text size='xs' c={'red'} mt={3}>
          {error}
        </Text>
      )}
    </Box>
  );
};

export default SegmentedInput;
